import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'

import { AssignPlayerOnPitchConfig } from '../../configuration'

export const assignPlayerOnPitchConfig: AssignPlayerOnPitchConfig<VolleyballIncidentId> =
  {
    assignPlayerOnPitchIncidents: new Set([
      VolleyballIncidentId.ServiceAce,
      VolleyballIncidentId.ServiceError,
      VolleyballIncidentId.AttackPoint,
      VolleyballIncidentId.AttackError,
      VolleyballIncidentId.BlockPoint,
      VolleyballIncidentId.TechnicalErrors,
      VolleyballIncidentId.Point,
      VolleyballIncidentId.Serve,
    ]),
  }
